export const SYSTEM_MESSAGES = {
    SENT: 'Message has been successfully sent',
    EMPTY_SUBJECT: `Subject field can't be blank`,
};

export const SNACK_TIMEOUT = 5000;